<script>
    let list_playlists = [
        {
            name: 'Speedtrack',
            desc: 'Top picks from my other playlists',
            link: 'https://open.spotify.com/playlist/4S7cPgjLGolQ9vBF89o74a?si=eaf263f6f6a847c7'
        },
        {
            name: 'Feeling down ?',
            desc: 'Motivational-ish songs',
            link: 'https://open.spotify.com/playlist/55I83AI21H8SEyLuYwxgmn?si=020e1fe20bfe4e7f'
        },
        {
            name: 'All dem songs',
            desc: 'There is something for everyone - just shuffle and enjoy!',
            link: 'https://open.spotify.com/playlist/1OfZlsGDohyG7yQKVipoeS?si=2e0e4d114bf54983'
        }
    ];
</script>

<style>
    .list {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .playlist {
        display: flex;
        align-items: baseline;
        padding: 10px;
        border-radius: 8px;
        text-decoration: none;
        background: #363636;
        color: inherit;
    }

    .playlist > i {
        margin-right: 10px;
        flex-shrink: 0;
        color: #1DB954;
    }

    .playlist > .info {
        display: flex;
        flex-direction: column;
        gap: 5px;
    }

    .playlist .name {
        font-weight: 500;
    }

    .playlist .description {
        color: #aaa;
    }

    .playlist:hover {
        box-shadow: 0 0 0 3px #545454;
    }
</style>

<div class="block-title">
    <h2>Favorite playlists</h2>
</div>

<div class="list">
    {#each list_playlists as playlist}
        <a class="playlist" href="{playlist.link}" target="_blank" rel="noopener noreferrer">
            <i class="fab fa-spotify"></i>
            <div class="info">
                <div class="name">{playlist.name}</div>
                {#if playlist.desc}
                    <div class="description">{playlist.desc}</div>
                {/if}
            </div>
        </a>
    {/each}
</div>
